import './style.less'

interface AlertMessage {
  msg: string
  timer?: number
  type?: 'success' | 'error' | 'warning'
}
export const alertMessage = (info: AlertMessage) => {
  const { msg, timer = 2000, type = 'success' } = info
  const outerEl = document.createElement('div')
  outerEl.className = 'alert-message'
  const innerEl = document.createElement('div')
  const classNames = ['inner']
  classNames.push(type)
  innerEl.className = classNames.join(' ')
  innerEl.innerText = msg
  outerEl.appendChild(innerEl)
  document.body.appendChild(outerEl)
  setTimeout(() => {
    if (outerEl) {
      outerEl.remove()
    }
  }, timer)
}

interface DialogMessage {
  title?: string
  digest?: string
  confirm?: string
  cancel?: string
  onConfirm?: () => void
}
export const dialogMessage = (params: DialogMessage) => {
  const { title = '', digest = '', confirm = '确定', cancel = '取消', onConfirm } = params
  const el = document.createElement('div')
  el.className = 'dialog-message'
  el.innerHTML = `
    <div class="box">
      <div class="top">
        <span>提示</span>
        <button class="close"></button>
      </div>
      <div class="text">
        <div class="title">${title}</div>
        <div class="digest">${digest}</div>
      </div>
      <div class="buttons">
        <button class="cancel">${cancel}</button>
        <button class="confirm">${confirm}</button>
      </div>
    </div>
  `
  el.querySelector('.close')?.addEventListener('click', () => {
    el.remove()
  })
  el.querySelector('.cancel')?.addEventListener('click', () => {
    el.remove()
  })
  el.querySelector('.confirm')?.addEventListener('click', () => {
    el.remove()
    if (onConfirm) {
      onConfirm()
    }
  })
  document.body.appendChild(el)
}
